import React from "react";

const LoadingIndicator = function LoadingIndicator() {
  return <div>Loading</div>;
};

export default LoadingIndicator;
